<template>
  <div class="customcomment-list">
    <Row>
      <Col :xs="24" :sm="12">
        <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
          <FormItem>
            <Select v-model="formItem.status" clearable style="width:180px" placeholder="请选择状态...">
              <Option v-for="item in statusList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
            <Button type="primary" @click="renderTable('formItem')">查找</Button>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <Table row-key="comment_id" :columns="list" :data="tablelist" :loading="dataloading" border></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page
          ref="listPage"
          :total="pages.total"
          :current="pages.page"
          :page-size="pages.size"
          show-elevator
          show-total
          @on-change="changePage()"
        ></Page>
      </div>
    </div>
    <!-- 详情的弹出 -->
    <Drawer
      title="详情"
      v-model="showModalStatus"
      width="60"
      scrollable
      :loading="loading"
      :mask-closable="false"
    >
      <List>
        <ListItem>
          <template>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">评论名称:</span>
                {{dataInfo.username }} {{dataInfo.nickname }}
              </label>
            </li>
          </template>
        </ListItem>
        <ListItem>
          <template>
            <li style="padding-right: 30px;">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">评论内容:</span>
                {{dataInfo.comment_content }}
              </label>
            </li>
          </template>
        </ListItem>
        <ListItem>
          <Row :gutter="16">
            <Col span="24">
              <label style="font-size: 14px;">
                <span style="font-size: 14px;font-weight: bold">图集:</span>
              </label>
              <div v-if="dataInfo.comment_attr!=null&&dataInfo.comment_attr!=''">
                <img
                  v-for="(item,key) in dataInfo.comment_attr"
                  :src="item"
                  style="width: 150px;height: auto;"
                  @click="showViewer(item)"
                />
              </div>
            </Col>
          </Row>
        </ListItem>
      </List>
    </Drawer>
    <!-- 图片查看 start -->
    <viewer
      :options="viewerOptions"
      :images="viewerImages"
      @inited="inited"
      class="viewerImageWraper"
      ref="viewerImageWraper"
    >
      <template slot-scope="scope">
        <figure class="images">
          <div class="image-wrapper" v-for="img in viewerImages" :key="img">
            <img class="image" :src="img" :data-source="img" :alt="img" style="display: none;" />
          </div>
        </figure>
      </template>
    </viewer>
    <!-- 图片查看 end -->
  </div>
</template>

<script>
export default {
  name: "customcomment-list",
  data() {
    return {
      viewerOptions: {
        toolbar: true,
        url: "data-source"
      },
      loading: true,
      dataloading: true,
      comment_id: 0,
      thumblist: [],
      tableTicketlist: [],
      statusList: [
        { id: 1, name: "下架" },
        { id: 0, name: "正常" }
      ],
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      title: "",
      formItem: {
        key: ""
      },
      list: [
        {
          title: "Id",
          key: "comment_id",
          fixed: "left",
          width: 90,
          tree: true
        },
        {
          title: "内容",
          key: "content",
          Width: 200,
          ellipsis: true,
          tooltip: true
        },
        {
          title: "评论人",
          key: "username",
          width: 150
        },
        {
          title: "评论人昵称",
          key: "nickname",
          width: 150
        },
        {
          title: "状态",
          key: "status",
          width: 100,
          render: (h, params) => {
            return h("div", [
              h("span", {}, params.row.status == 0 ? "正常" : "下架")
            ]);
          }
        },
        {
          title: "评论时间",
          key: "created_at",
          width: 150
        },
        {
          title: "操作",
          key: "action",
          width: 350,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.index, params.row.comment_id);
                    }
                  }
                },
                "详情"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.index, params.row.comment_id);
                    }
                  }
                },
                "删除"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    // type: "warning",
                    type: params.row.status == 0 ? "warning" : "success",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      params.row.status == 0
                        ? this.editStatus(params.row.comment_id, 1)
                        : this.editStatus(params.row.comment_id, 0);
                    }
                  }
                },
                params.row.status == 0 ? "下架" : "正常"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      showModalStatus: false,
      thumblist: [],
      thumblistTwo: [],
      dataInfo: {},
      isClear: false,
      params: {},
      viewerImages: []
    };
  },
  // 组件
  components: {},
  created: function() {
    this.thumb_id = this.$route.params.id;
    // 取数据
    this.getTableList();
  },
  methods: {
    inited(viewer) {
      this.$viewer = viewer;
    },
    getTableList: function() {
      this.$api.tradesmanthumbcomment
        .list({
          page: this.pages.page,
          size: this.pages.size,
          thumb_id: this.thumb_id
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
      return;
    },
    showViewer(photo) {
      let imgs = [];
      imgs.push(photo);
      this.viewerImages = imgs;
      this.$viewer.show();
    },
    // 详情
    detail(index, id) {
      this.title = "详情";
      this.$api.tradesmanthumbcomment.detail({ comment_id: id }).then(res => {
        this.showModalStatus = !this.showModalStatus;
        this.dataInfo = res.result;
        this.dataInfo.comment_attr = JSON.parse(this.dataInfo.comment_attr);
        console.log(this.dataInfo);
        // this.dataInfo.tradesman_name =
        //   res.result.tradesman == "" && res.result.tradesman.nickname == ""
        //     ? ""
        //     : res.result.tradesman.nickname;
        // this.dataInfo.area1_name = res.result.provice.areaname;
        // this.dataInfo.area2_name = res.result.city.areaname;
        // this.dataInfo.area3_name = res.result.area.areaname;
        // this.dataInfo.pos_flag_name = res.result.pos_flag == 1 ? "是" : "否";
        // this.tableTicketlist = res.result.ticket;
        // this.editInfo.id = this.dataInfo.id;
        // this.editInfo.remark = this.dataInfo.remark;
        // this.editInfo.pos_flag = this.dataInfo.pos_flag;
        // this.editInfo.status = this.dataInfo.status;
        // this.editInfo.sort = this.dataInfo.sort;
      });
    },
    // 删除
    remove: function(index, id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.tradesmanthumbcomment
            .remove({ comment_id: id })
            .then(res => {
              if (res.code == 200) {
                this.$Message.success(res.msg);
                this.getTableList();
              }
            });
        }
      });
    },
    // 翻页
    changePage() {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function(name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        status: this.formItem.status,
        page: this.pages.page,
        size: this.pages.size,
        thumb_id: this.thumb_id
      };
      this.$api.tradesmanthumbcomment.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 上下架
    editStatus: function(id, index) {
      this.$api.tradesmanthumbcomment
        .status({ comment_id: id, status: index })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success(res.msg);
            this.getTableList();
          }
        });
    }
  }
};
</script>

<style scoped>
</style>